import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import MediaQueries, { createMediaQuery, } from '@polestar/component-warehouse-react/tokens/media-queries/MediaQueries';
import DeviceTypes from '@polestar/component-warehouse-react/tokens/device-types/DeviceTypes';
import Breakpoints from '@polestar/component-warehouse-react/tokens/breakpoints/Breakpoints';
import { shouldNotForwardProps } from '@polestar/component-warehouse-react/helpers/shouldForwardProps';
import { GridContext } from './Grid';
const spanTypes = Object.keys(DeviceTypes);
const GridColumn = forwardRef(({ offset, ...props }, ref) => {
    // It's allowed to not set mobile for offset, force it on 0 (hidden)
    if (offset && !(offset === null || offset === void 0 ? void 0 : offset.mobile)) {
        offset = {
            mobile: 0,
            ...offset,
        };
    }
    return (React.createElement(GridContext.Provider, { value: { span: props.span } },
        offset ? React.createElement(StyledColumn, { span: offset }) : null,
        React.createElement(StyledColumn, { ...props, ref: ref })));
});
GridColumn.displayName = 'GridColumn';
export default GridColumn;
/**
 * To ensure that <GridColumn={{mobile: 'hidden', tablet: 2}}/> has no effect
 * on the display property for the tablet or above breakpoints a `max-width`
 * is needed to box the environment where the GridColumn should be hidden
 */
const MediaQueriesRanged = Object.freeze({
    mobile: createMediaQuery(Breakpoints.mobile, 'media', Breakpoints.tablet - 1),
    tablet: createMediaQuery(Breakpoints.tablet, 'media', Breakpoints.desktop - 1),
    desktop: createMediaQuery(Breakpoints.desktop, 'media', Breakpoints.desktopWide - 1),
    desktopWide: createMediaQuery(Breakpoints.desktopWide),
});
const StyledColumn = styled('div', shouldNotForwardProps(true, 'span'))((props) => {
    const styles = [
        // This is needed for webkit, otherwise it doesn't scale properly when content is bigger
        css `
      min-width: 0;
      min-height: 0;
    `,
    ];
    // Loop over devicetypes and only add css when needed
    spanTypes.forEach((device) => {
        const deviceSpan = device === DeviceTypes.mobile && props.span[device] === undefined ? 0 : props.span[device];
        if (deviceSpan !== undefined) {
            const display = deviceSpan === 'hidden' || deviceSpan === 0 ? 'display: none;' : '';
            const gridColumn = deviceSpan !== undefined && typeof deviceSpan === 'number'
                ? `grid-column: span ${deviceSpan};`
                : '';
            if (display) {
                /**
                 * use MediaQueriesRanged to ensure that columns are only hidden
                 * were they were defined to be hidden
                 */
                styles.push(css `
          ${MediaQueriesRanged[device]} {
            ${display}
          }
        `);
            }
            if (gridColumn) {
                if (device === DeviceTypes.mobile) {
                    styles.push(css `
            ${gridColumn}
          `);
                }
                else {
                    styles.push(css `
            ${MediaQueries[device]} {
              ${gridColumn}
            }
          `);
                }
            }
        }
    });
    return styles;
});
